import { setCategoriesList } from "../reducers/categories"
import { setChoicesList } from "../reducers/choices"
import { setDomainesList } from "../reducers/domaines"
import { setParcoursList } from "../reducers/parcours"
import { setQuestionsList } from "../reducers/questions"

import { store } from "../store/store"
import axios from "axios"
import { setQuizzProfileList } from "../reducers/quizzprofile"
import { setAttemptedQuizzList } from "../reducers/tentatives"
import { setTechnologyList, settechnologyList } from "../reducers/technologies"
import { setNiveauList } from "../reducers/niveau"
import { setAtelierList } from "../reducers/ateliers"
import { setExercicesList } from "../reducers/exercice_zone/exercices"
import { setReponsesList } from "../reducers/exercice_zone/reponses"
import { setChallengeProfileList } from "../reducers/exercice_zone/challengeProfile"
import { setAttemptedChallengeList } from "../reducers/exercice_zone/tentativesChallenge"

const { CATEGORIES_API_ROUTE, PARCOURS_API_ROUTE, DOMAINES_API_ROUTE, 
        QUESTIONS_API_ROUTE, CHOICES_API_ROUTE, QUIZZ_PROFILE_API_ROUTE, 
        ATTEMPTED_API_ROUTE, TECHNOLOGY_API_ROUTE, NIVEAU_API_ROUTE, ATELIERS,
        EXERCICE_API_ROUTE,CHALLENGE_EXO_API_ROUTE,REPONSE_API_ROUTE,
        ATTEMPTED_REPONSE_API_ROUTE } = require("../../routes/api/api_routes")



const all = {
    getAllData(){
        return new Promise((resolve,reject)=>{
            let dispatch= store.dispatch

            const config = {
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`JWT ${localStorage.getItem('access')}`,
                    'Accept':'application/json'
                }
              };

            axios.get(CATEGORIES_API_ROUTE,config)
            .then(response => {
                if(response.status ===200){
                    let catrgories = response.data.data
                    dispatch(setCategoriesList(catrgories))
                }
            })
            axios.get(PARCOURS_API_ROUTE,config)
            .then(response => {
                if(response.status ===200){
                    let catrgories = response.data.data
                    dispatch(setParcoursList(catrgories))
                }
            })
            axios.get(DOMAINES_API_ROUTE,config)
            .then(response => {
                if(response.status ===200){
                    let doamines = response.data.data
                    dispatch(setDomainesList(doamines))
                }
            })
            axios.get(QUESTIONS_API_ROUTE,config)
            .then(response => {
                if(response.status ===200){
                    let questions = response.data.data
                    dispatch(setQuestionsList(questions))
                }
            })
            axios.get(CHOICES_API_ROUTE,config)
            .then(response => {
                if(response.status ===200){
                    let choices = response.data.data
                    dispatch(setChoicesList(choices))
                }
            })
            axios.get(QUIZZ_PROFILE_API_ROUTE,config)
            .then(response => {
                if(response.status === 200){
                    let quizzprofiles = response.data.data
                    dispatch(setQuizzProfileList(quizzprofiles))
                }
            })
            axios.get(ATTEMPTED_API_ROUTE,config)
            .then(response => {
                if(response.status ===200){
                    let attempted = response.data.data
                    dispatch(setAttemptedQuizzList(attempted))
                }
            })
            axios.get(TECHNOLOGY_API_ROUTE,config)
            .then(response => {
                if(response.status ===200){
                    let technologies = response.data.data
                    dispatch(setTechnologyList(technologies))
                }
            })
            axios.get(NIVEAU_API_ROUTE,config)
            .then(response => {
                if(response.status ===200){
                    let niveaux = response.data.data
                    dispatch(setNiveauList(niveaux))
                }
            })
            axios.get(ATELIERS,config)
            .then(response => {
                if(response.status ===200){
                    let ateliers = response.data.data
                    console.log("Mes ateliers: ",ateliers)
                    dispatch(setAtelierList(ateliers))
                }
            })
            axios.get(EXERCICE_API_ROUTE,config)
            .then(response => {
                if(response.status ===200){
                    let exercices = response.data.data
                    console.log("Mes exercices: ",exercices)
                    dispatch(setExercicesList(exercices))
                }
            })
            axios.get(REPONSE_API_ROUTE,config)
            .then(response => {
                if(response.status ===200){
                    let reponses = response.data.data
                    console.log("Mes reponses: ",reponses)
                    dispatch(setReponsesList(reponses))
                }
            })
            axios.get(CHALLENGE_EXO_API_ROUTE,config)
            .then(response => {
                if(response.status ===200){
                    let challenges = response.data.data
                    console.log("Mes challenges: ",challenges)
                    dispatch(setChallengeProfileList(challenges))
                }
            })
            axios.get(ATTEMPTED_REPONSE_API_ROUTE,config)
            .then(response => {
                if(response.status ===200){
                    let attempted_reponses = response.data.data
                    console.log("Mes attempts: ",attempted_reponses)
                    dispatch(setAttemptedChallengeList(attempted_reponses))
                }
            })
            .catch(error => {console.log(error)})
        })
    },
}
export default all